import { render, staticRenderFns } from "./CRM.vue?vue&type=template&id=2f5ea7ae&lang=pug"
import script from "./CRM.vue?vue&type=script&lang=js"
export * from "./CRM.vue?vue&type=script&lang=js"
import style0 from "./CRM.vue?vue&type=style&index=0&id=2f5ea7ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports